import { BillRepository } from "../../domain/repositories/BillRepository";
import { BillsResultEntity, ZohoBillDetailsEntity } from "../../domain/entities/BillListItemEntity";
import { getBillsForVendor, getZohoBillDetails } from "../api/getVendorBillsApi";
import { BillMapper } from "../mappers/BillMapper";

export class BillRepositoryImpl implements BillRepository {
  async getBillsForVendor(
    vendorZohoId: string,
    limit?: number,
    offset?: number,
    search?: string
  ): Promise<BillsResultEntity> {
    const dto = await getBillsForVendor(vendorZohoId, limit, offset, search);
    return BillMapper.toResultEntity(dto);
  }

  async getZohoBillDetails(zohoBillId: string): Promise<ZohoBillDetailsEntity> {
    const dto = await getZohoBillDetails(zohoBillId);
    // Map DTO to entity (they have the same structure, so we can return directly)
    return dto.data;
  }
}

